import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["filterFamily", "resolver"];
import { getInboundDbImportReferenceResolver } from 'customer-data-filters-ui/utils/getInboundDbImportReferenceResolver';
import FilterOperatorEnumInput from './FilterOperatorEnumInput';
import { jsx as _jsx } from "react/jsx-runtime";
const FilterOperatorInboundDbImportInput = _ref => {
  let {
      filterFamily,
      resolver
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return (
    /*#__PURE__*/
    // @ts-expect-error ts-migrate(2739) FIXME: Type '{ filterFamily: string; resolver: any; }' is... Remove this comment to see the full error message
    _jsx(FilterOperatorEnumInput, Object.assign({
      filterFamily: filterFamily,
      resolver: getInboundDbImportReferenceResolver(resolver, filterFamily)
    }, rest))
  );
};
export default FilterOperatorInboundDbImportInput;